<template>
  <button @click="onClick()" class="mb-2">
    <img v-if="icon !== ''" :src="icon" alt="" />
    <span>{{ caption }}</span>
  </button>
</template>

<script>
export default {
  props: {
    caption: String,
    icon: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    },
  },
};
</script>

<style scoped lang="scss">
button {
  border: none;
  outline: none;
  color: #fff;
  background-color: #303030;
  height: 46px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 10px 14px;
  margin-right: 10px;
  img {
    height: 20px;
    margin-right: 15px;
  }
}
@media screen and (max-width: 480px) and (min-width: 0) {
  button {
    margin-right: 0;
  }
}
</style>
